﻿import { get } from "@/Utils"
import { handleSuccess, handleError } from "@/Validation.js";
import { ExportedRegularExpressions } from "@/enums";


function showPrivate() {
  const registerPrivate = get("register-private") as HTMLButtonElement;
  const registerCorporate = get("register-corporate") as HTMLButtonElement;
  if (registerCorporate.disabled) return;

  registerPrivate.classList.add("button--tertiary");
  registerPrivate.classList.remove("button--secondary");
  registerCorporate.classList.add("button--secondary");
  registerCorporate.classList.remove("button--tertiary");
  const isCorporate = (get("IsCorporate") as HTMLInputElement);
  if (isCorporate) {
    (get("IsCorporate") as HTMLInputElement).value = "False";
  }

  const registrationContainer = get("registration-container") as HTMLFormElement;
  registrationContainer?.classList.add("register-private");
  registrationContainer?.classList.remove("register-corporate");
}
function showCorporate() {
  const registerPrivate = get("register-private") as HTMLButtonElement;
  const registerCorporate = get("register-corporate") as HTMLButtonElement;
  if (registerCorporate.disabled) return;

  registerPrivate.classList.remove("button--tertiary");
  registerPrivate.classList.add("button--secondary");
  registerCorporate.classList.remove("button--secondary");
  registerCorporate.classList.add("button--tertiary");
  const isCorporate = (get("IsCorporate") as HTMLInputElement);
  if (isCorporate) {
    (get("IsCorporate") as HTMLInputElement).value = "True";
  }

  const registrationContainer = get("registration-container") as HTMLFormElement;
  registrationContainer?.classList.remove("register-private");
  registrationContainer?.classList.add("register-corporate");
}

export function initToggleButtons() {
  const registerPrivate = get("register-private") as HTMLButtonElement;
  const registerCorporate = get("register-corporate") as HTMLButtonElement;
  registerPrivate?.addEventListener("click", () => showPrivate());
  registerCorporate?.addEventListener("click", () => showCorporate());
}

//Mõeldud ainult kasutajale koheseks visuaalseks tagasisideks. Backendis on eraldi kontroll ka olemas.
export function initPasswordChecks() {
    const password = get("Password_Password") as HTMLInputElement;
    const confirmPassword = get("Password_PasswordConfirmation") as HTMLInputElement;
    const passwordRegex: RegExp = new RegExp(ExportedRegularExpressions.PasswordRegEx);

    password?.addDataBoundEventListener("blur", () => {
        if(password.value === ""){
            handleError(password, "")
        }else if (!passwordRegex.test(password.value)) {
            const validationMessage = password.getAttribute("data-secondary-validation-failure");
            handleError(password, validationMessage)
        } else {
            handleSuccess(password)
        }
    });
    confirmPassword?.addDataBoundEventListener("blur", () => {
        if(confirmPassword.value === "") {
            handleError(confirmPassword, "")
        } else if (password.value != confirmPassword.value) {
            const validationMessage = confirmPassword.getAttribute("data-secondary-validation-failure");
            handleError(confirmPassword, validationMessage)
        } else {
            handleSuccess(confirmPassword)
        }
    });
}